/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LocaleRouteImport } from './routes/$locale'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LocaleDashboardRouteRouteImport } from './routes/$locale.dashboard/route'
import { Route as LocaleDashboardIndexRouteImport } from './routes/$locale.dashboard/index'
import { Route as LocaleDashboardSettingsRouteImport } from './routes/$locale.dashboard/settings'
import { Route as LocaleDashboardDebugLogsRouteImport } from './routes/$locale.dashboard/debug-logs'
import { Route as LocaleDashboardBrowserRouteImport } from './routes/$locale.dashboard/browser'
import { Route as LocaleDashboardDecksDeckIdRouteImport } from './routes/$locale.dashboard/decks.$deckId'
import { Route as LocaleDashboardDecksDeckIdReviewRouteImport } from './routes/$locale.dashboard_.decks.$deckId.review'

const LocaleRoute = LocaleRouteImport.update({
  id: '/$locale',
  path: '/$locale',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LocaleDashboardRouteRoute = LocaleDashboardRouteRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleDashboardIndexRoute = LocaleDashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LocaleDashboardRouteRoute,
} as any)
const LocaleDashboardSettingsRoute = LocaleDashboardSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => LocaleDashboardRouteRoute,
} as any)
const LocaleDashboardDebugLogsRoute =
  LocaleDashboardDebugLogsRouteImport.update({
    id: '/debug-logs',
    path: '/debug-logs',
    getParentRoute: () => LocaleDashboardRouteRoute,
  } as any)
const LocaleDashboardBrowserRoute = LocaleDashboardBrowserRouteImport.update({
  id: '/browser',
  path: '/browser',
  getParentRoute: () => LocaleDashboardRouteRoute,
} as any)
const LocaleDashboardDecksDeckIdRoute =
  LocaleDashboardDecksDeckIdRouteImport.update({
    id: '/decks/$deckId',
    path: '/decks/$deckId',
    getParentRoute: () => LocaleDashboardRouteRoute,
  } as any)
const LocaleDashboardDecksDeckIdReviewRoute =
  LocaleDashboardDecksDeckIdReviewRouteImport.update({
    id: '/dashboard_/decks/$deckId/review',
    path: '/dashboard/decks/$deckId/review',
    getParentRoute: () => LocaleRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/$locale': typeof LocaleRouteWithChildren
  '/$locale/dashboard': typeof LocaleDashboardRouteRouteWithChildren
  '/$locale/dashboard/browser': typeof LocaleDashboardBrowserRoute
  '/$locale/dashboard/debug-logs': typeof LocaleDashboardDebugLogsRoute
  '/$locale/dashboard/settings': typeof LocaleDashboardSettingsRoute
  '/$locale/dashboard/': typeof LocaleDashboardIndexRoute
  '/$locale/dashboard/decks/$deckId': typeof LocaleDashboardDecksDeckIdRoute
  '/$locale/dashboard/decks/$deckId/review': typeof LocaleDashboardDecksDeckIdReviewRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/$locale': typeof LocaleRouteWithChildren
  '/$locale/dashboard/browser': typeof LocaleDashboardBrowserRoute
  '/$locale/dashboard/debug-logs': typeof LocaleDashboardDebugLogsRoute
  '/$locale/dashboard/settings': typeof LocaleDashboardSettingsRoute
  '/$locale/dashboard': typeof LocaleDashboardIndexRoute
  '/$locale/dashboard/decks/$deckId': typeof LocaleDashboardDecksDeckIdRoute
  '/$locale/dashboard/decks/$deckId/review': typeof LocaleDashboardDecksDeckIdReviewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/$locale': typeof LocaleRouteWithChildren
  '/$locale/dashboard': typeof LocaleDashboardRouteRouteWithChildren
  '/$locale/dashboard/browser': typeof LocaleDashboardBrowserRoute
  '/$locale/dashboard/debug-logs': typeof LocaleDashboardDebugLogsRoute
  '/$locale/dashboard/settings': typeof LocaleDashboardSettingsRoute
  '/$locale/dashboard/': typeof LocaleDashboardIndexRoute
  '/$locale/dashboard/decks/$deckId': typeof LocaleDashboardDecksDeckIdRoute
  '/$locale/dashboard_/decks/$deckId/review': typeof LocaleDashboardDecksDeckIdReviewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/$locale'
    | '/$locale/dashboard'
    | '/$locale/dashboard/browser'
    | '/$locale/dashboard/debug-logs'
    | '/$locale/dashboard/settings'
    | '/$locale/dashboard/'
    | '/$locale/dashboard/decks/$deckId'
    | '/$locale/dashboard/decks/$deckId/review'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/$locale'
    | '/$locale/dashboard/browser'
    | '/$locale/dashboard/debug-logs'
    | '/$locale/dashboard/settings'
    | '/$locale/dashboard'
    | '/$locale/dashboard/decks/$deckId'
    | '/$locale/dashboard/decks/$deckId/review'
  id:
    | '__root__'
    | '/'
    | '/$'
    | '/$locale'
    | '/$locale/dashboard'
    | '/$locale/dashboard/browser'
    | '/$locale/dashboard/debug-logs'
    | '/$locale/dashboard/settings'
    | '/$locale/dashboard/'
    | '/$locale/dashboard/decks/$deckId'
    | '/$locale/dashboard_/decks/$deckId/review'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SplatRoute: typeof SplatRoute
  LocaleRoute: typeof LocaleRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$locale': {
      id: '/$locale'
      path: '/$locale'
      fullPath: '/$locale'
      preLoaderRoute: typeof LocaleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$locale/dashboard': {
      id: '/$locale/dashboard'
      path: '/dashboard'
      fullPath: '/$locale/dashboard'
      preLoaderRoute: typeof LocaleDashboardRouteRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/dashboard/': {
      id: '/$locale/dashboard/'
      path: '/'
      fullPath: '/$locale/dashboard/'
      preLoaderRoute: typeof LocaleDashboardIndexRouteImport
      parentRoute: typeof LocaleDashboardRouteRoute
    }
    '/$locale/dashboard/settings': {
      id: '/$locale/dashboard/settings'
      path: '/settings'
      fullPath: '/$locale/dashboard/settings'
      preLoaderRoute: typeof LocaleDashboardSettingsRouteImport
      parentRoute: typeof LocaleDashboardRouteRoute
    }
    '/$locale/dashboard/debug-logs': {
      id: '/$locale/dashboard/debug-logs'
      path: '/debug-logs'
      fullPath: '/$locale/dashboard/debug-logs'
      preLoaderRoute: typeof LocaleDashboardDebugLogsRouteImport
      parentRoute: typeof LocaleDashboardRouteRoute
    }
    '/$locale/dashboard/browser': {
      id: '/$locale/dashboard/browser'
      path: '/browser'
      fullPath: '/$locale/dashboard/browser'
      preLoaderRoute: typeof LocaleDashboardBrowserRouteImport
      parentRoute: typeof LocaleDashboardRouteRoute
    }
    '/$locale/dashboard/decks/$deckId': {
      id: '/$locale/dashboard/decks/$deckId'
      path: '/decks/$deckId'
      fullPath: '/$locale/dashboard/decks/$deckId'
      preLoaderRoute: typeof LocaleDashboardDecksDeckIdRouteImport
      parentRoute: typeof LocaleDashboardRouteRoute
    }
    '/$locale/dashboard_/decks/$deckId/review': {
      id: '/$locale/dashboard_/decks/$deckId/review'
      path: '/dashboard/decks/$deckId/review'
      fullPath: '/$locale/dashboard/decks/$deckId/review'
      preLoaderRoute: typeof LocaleDashboardDecksDeckIdReviewRouteImport
      parentRoute: typeof LocaleRoute
    }
  }
}

interface LocaleDashboardRouteRouteChildren {
  LocaleDashboardBrowserRoute: typeof LocaleDashboardBrowserRoute
  LocaleDashboardDebugLogsRoute: typeof LocaleDashboardDebugLogsRoute
  LocaleDashboardSettingsRoute: typeof LocaleDashboardSettingsRoute
  LocaleDashboardIndexRoute: typeof LocaleDashboardIndexRoute
  LocaleDashboardDecksDeckIdRoute: typeof LocaleDashboardDecksDeckIdRoute
}

const LocaleDashboardRouteRouteChildren: LocaleDashboardRouteRouteChildren = {
  LocaleDashboardBrowserRoute: LocaleDashboardBrowserRoute,
  LocaleDashboardDebugLogsRoute: LocaleDashboardDebugLogsRoute,
  LocaleDashboardSettingsRoute: LocaleDashboardSettingsRoute,
  LocaleDashboardIndexRoute: LocaleDashboardIndexRoute,
  LocaleDashboardDecksDeckIdRoute: LocaleDashboardDecksDeckIdRoute,
}

const LocaleDashboardRouteRouteWithChildren =
  LocaleDashboardRouteRoute._addFileChildren(LocaleDashboardRouteRouteChildren)

interface LocaleRouteChildren {
  LocaleDashboardRouteRoute: typeof LocaleDashboardRouteRouteWithChildren
  LocaleDashboardDecksDeckIdReviewRoute: typeof LocaleDashboardDecksDeckIdReviewRoute
}

const LocaleRouteChildren: LocaleRouteChildren = {
  LocaleDashboardRouteRoute: LocaleDashboardRouteRouteWithChildren,
  LocaleDashboardDecksDeckIdReviewRoute: LocaleDashboardDecksDeckIdReviewRoute,
}

const LocaleRouteWithChildren =
  LocaleRoute._addFileChildren(LocaleRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SplatRoute: SplatRoute,
  LocaleRoute: LocaleRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
